import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {WonTitleAssetRequestParams} from "../../../competitions-slider-widget/models/assets/won-title-asset.request-params";
import {Image} from "../../../../core/components/image/image";
import {StandingsDestinationViewModel} from "../../../../domain/standings/models/destinations/standings.destinations.view-model";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {STANDINGS_WIDGET} from "../../standings-widget.consts";

export class StandingsWidgetCompetitorWinnerLogoProps extends BaseProps {
  row: StandingsDestinationViewModel;
}

export const StandingsWidgetCompetitorWinnerLogo = ({row}: StandingsWidgetCompetitorWinnerLogoProps) => {
  const {isWinner} = row;

  const imageProps = {
    src: new WonTitleAssetRequestParams(STANDINGS_WIDGET.ICONS.COMPETITOR_WINNER_LOGO, STANDINGS_WIDGET.ICONS.COMPETITOR_WINNER_LOGO),
    className: classNames(styles.competitor_won_title)
  }

  return isWinner ? <Image {...imageProps}/> : null;
};
